import React from "react";
import HTMLParser from "html-react-parser";
import styled, { css } from "styled-components";
import { decode } from "html-entities";
import DOMPurify from "dompurify";

interface HtmlBodyProps {
  body: string;
  className?: string;
}

const HtmlBody: React.ReactFCWithChildren<HtmlBodyProps> = props => {
  const decodedBody = React.useMemo(() => {
    const decodedHTML = decode(props.body);

    return DOMPurify.sanitize(decodedHTML);
  }, [ props.body ]);

  return (
    <NoteBody className={`note-body ${props.className ?? ""}`}>
      {HTMLParser(decodedBody)}
    </NoteBody>
  );
};

const NoteBody = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.fonts.sizes.p};
    color: ${theme.fonts.colors.primary};
    letter-spacing: 0;
    font-weight: 400;
    line-height: 1.4em;

    ul {
      list-style: inherit;
      padding-top: ${theme.spacing.padding.sm};
      margin-left: ${theme.fonts.sizes.p};
      li {
        letter-spacing: 0;
        font-weight: 400;
        line-height: 1.4em;
        font-size: ${theme.fonts.sizes.p};
        color: ${theme.fonts.colors.primary};
      }
    }
    p {
      padding-top: ${theme.spacing.padding.sm};
      letter-spacing: 0;
      font-weight: 400;
      line-height: 1.4em;
      font-size: ${theme.fonts.sizes.p};
      color: ${theme.fonts.colors.primary};
      margin-bottom: ${theme.spacing.padding.md};

      b,
      strong {
        font-weight: ${theme.fonts.weights.bold};
      }
      em {
        font-style: italic;
      }
      u,
      ins {
        text-decoration: underline;
      }
    }
    h1 {
      font-size: ${theme.fonts.sizes.h1};
    }
    h2 {
      font-size: ${theme.fonts.sizes.h2};
    }
    h3 {
      font-size: ${theme.fonts.sizes.h3};
    }
    h4 {
      font-size: ${theme.fonts.sizes.h4};
    }
    h5 {
      font-size: ${theme.fonts.sizes.h5};
    }
    h6 {
      font-size: ${theme.fonts.sizes.h6};
    }
  `}
`;

export default HtmlBody;
